/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 32 32" }, this.props),
            React.createElement("path", { d: "m31 0c.553 0 1 .448 1 1v30c0 .553-.447 1-1 1h-30c-.552 0-1-.447-1-1v-30c0-.552.448-1 1-1zm-29 30h28v-28h-28zm4.8149-16.5537-2.609-2.609c-.391-.391-.391-1.023 0-1.414s1.024-.391 1.414 0l1.902 1.902 5.814-5.815c.391-.391 1.024-.391 1.415 0 .39.391.39 1.023 0 1.414l-6.522 6.522c-.187.187-.442.293-.707.293s-.52-.106-.707-.293zm0 11.7392-2.609-2.609c-.391-.391-.391-1.024 0-1.414.391-.391 1.024-.391 1.414 0l1.902 1.902 5.814-5.816c.391-.39 1.024-.39 1.415 0 .39.391.39 1.024 0 1.415l-6.522 6.522c-.187.187-.442.293-.707.293s-.52-.106-.707-.293zm9.8374-12.7509c-.552 0-1-.448-1-1s.448-1 1-1h10.435c.552 0 1 .448 1 1s-.448 1-1 1zm0 11.7392c-.552 0-1-.447-1-1s.448-1 1-1h10.435c.552 0 1 .447 1 1s-.448 1-1 1z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;